export default {
  effects: ['crop', 'rotate', 'enhance', 'sharp', 'grayscale'],
  locale: 'en',
}
